import { ISmartFieldRenderProps } from "@components/smart/smartField/SmartField";
import { ISmartFieldEvents } from "@components/smart/smartField/SmartFieldUtils";
import BindingContext from "@odata/BindingContext";
import MonthCheckboxSelector, { MasterCheckboxType } from "@pages/payroll/Eldp/MonthCheckboxSelector";
import React, { useCallback } from "react";

interface IProps extends Omit<ISmartFieldRenderProps, "onBlur" | "onChange" | "onRowsChange">, ISmartFieldEvents {
    masterCheckboxType?: MasterCheckboxType;
    bindingContext?: BindingContext;
    isReadOnly?: boolean;
}

const SmartMonthCheckboxSelector: React.FC<IProps> = ({
                                                          info,
                                                          bindingContext,
                                                          onChange,
                                                          isReadOnly,
                                                          value,
                                                          masterCheckboxType
                                                      }) => {

    const handleChange = useCallback((newValue: string) => {
        onChange({
            value: newValue,
            bindingContext: bindingContext ?? info.bindingContext,
            previousValue: value
        });
    }, [info.bindingContext, bindingContext, onChange, value]);

    return (
        <MonthCheckboxSelector value={value}
                               masterCheckboxType={masterCheckboxType}
                               onChange={handleChange}
                               isReadOnly={isReadOnly}
                               name={info.id}/>
    );
};

export default SmartMonthCheckboxSelector;